export default __webpack_public_path__ + "static/media/cfx-cm-1.00f77711.png";